import { Component, ElementRef, HostBinding, OnInit, inject, input } from "@angular/core";

@Component({
  selector: "av-card-body",
  templateUrl: "./card-body.component.html",
  styleUrls: ["./card-body.component.scss"],
  standalone: false,
})
export class CardBodyComponent implements OnInit {
  host = inject<ElementRef<HTMLDivElement>>(ElementRef);

  readonly type = input<"spotlight" | "container" | "card">("card");
  readonly size = input<"lg" | "md" | "sm" | "xs">("md");

  classes = {};

  ngOnInit(): void {}

  @HostBinding("class") get class() {
    return {
      "panel-body-spotlight": this.type() === "spotlight",
      "panel-body-sm": this.size() === "sm",
      "panel-body-xs": this.size() == "xs",
      "panel-body-md": this.size() == "md",
      "panel-body-lg": this.size() == "lg",
      "panel-body-container": this.type() === "container",
      "panel-body-card": this.type() === "card",
    };
  }

  get nativeElement(): HTMLDivElement {
    return this.host.nativeElement;
  }
}
